export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/zapier.81783229.svg","height":32,"width":119,"blurWidth":0,"blurHeight":0};